{{ i18n.getDayNumerals(date) }}


// WEBPACK FOOTER //
// ./node_modules/@ng-bootstrap/ng-bootstrap/ng-bootstrap.d.ts.ɵg.html